/**
 * Icon — renders an SVG icon by name from the icon registry context.
 *
 * Passes `color` to the SVG root so internal `currentColor` references
 * resolve correctly. An optional `fill` prop overrides the SVG's own
 * fill attribute — omit it to let stroke-based icons render as outlines.
 */
import { type FC, memo } from "react";
import type { StyleProp, ViewStyle } from "react-native";
import "../theme";
import { useUnistyles } from "react-native-unistyles";
import type { IconName } from "../icons/icon-names";
import { useIconRegistry } from "../icons/IconContext";

export interface IconProps {
  readonly name: IconName;
  readonly size?: number;
  readonly color?: string;
  readonly fill?: string;
  readonly style?: StyleProp<ViewStyle>;
}

export const Icon: FC<IconProps> = memo(function Icon({ name, size = 24, color, fill, style }) {
  const { theme } = useUnistyles();
  const registry = useIconRegistry();
  const SvgIcon = registry[name];
  const resolvedColor = color ?? theme.colors.icon;

  return <SvgIcon width={size} height={size} color={resolvedColor} style={style} {...(fill ? { fill } : {})} />;
});
